import { useState, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";

import api from "../../services/api";

import * as S from "./styled";

import Template from "../../template";
import { useAuth } from "../../context/auth";
import MiniaturaFoto from "../../components/FotoUsuario/Miniatura";

/*
  Os filtros vivem também na query string da URL.

  Antes ficavam só em useState: ao abrir uma correção e voltar, a listagem
  remontava zerada e o professor tinha que refazer a busca inteira. Com os
  filtros na URL o "Voltar" devolve exatamente a lista que ele tinha montado,
  e o link de uma busca pode ser salvo ou compartilhado.
*/
const FILTRO_PADRAO = "2";
const ITENS_POR_PAGINA_PADRAO = 50;

function lerFiltrosDaUrl(search) {
  const q = new URLSearchParams(search);
  const pagina = parseInt(q.get("pagina"), 10);
  const porPagina = parseInt(q.get("porPagina"), 10);

  return {
    status: q.get("status") || FILTRO_PADRAO,
    aluno: q.get("aluno") || "",
    tema: q.get("tema") || "",
    turma: q.get("turma") || "",
    corretor: q.get("corretor") || "",
    dataInicio: q.get("de") || "",
    dataFim: q.get("ate") || "",
    correcaoInicio: q.get("cde") || "",
    correcaoFim: q.get("cate") || "",
    pagina: Number.isFinite(pagina) && pagina > 0 ? pagina : 1,
    porPagina: Number.isFinite(porPagina) && porPagina > 0 ? porPagina : ITENS_POR_PAGINA_PADRAO,
  };
}

/* "2026-10-09" -> "09/10/2026" sem passar por Date, que desloca o dia pelo fuso */
function dataBR(iso) {
  if (!iso) return "";

  const [ano, mes, dia] = String(iso).slice(0, 10).split("-");

  return ano && mes && dia ? `${dia}/${mes}/${ano}` : iso;
}

function montarQueryDeFiltros(f) {
  const q = new URLSearchParams();

  // só entra na URL o que difere do padrão, para o link não virar um paredão
  if (f.status !== FILTRO_PADRAO) q.set("status", f.status);
  if (f.aluno) q.set("aluno", f.aluno);
  if (f.tema) q.set("tema", f.tema);
  if (f.turma) q.set("turma", f.turma);
  if (f.corretor) q.set("corretor", f.corretor);
  if (f.dataInicio) q.set("de", f.dataInicio);
  if (f.dataFim) q.set("ate", f.dataFim);
  if (f.correcaoInicio) q.set("cde", f.correcaoInicio);
  if (f.correcaoFim) q.set("cate", f.correcaoFim);
  if (f.pagina > 1) q.set("pagina", String(f.pagina));
  if (f.porPagina !== ITENS_POR_PAGINA_PADRAO) q.set("porPagina", String(f.porPagina));

  const s = q.toString();
  return s ? `?${s}` : "";
}

function RedacoesUERJ() {
  const location = useLocation();
  // lido uma única vez na montagem: depois quem manda é o state
  const [filtrosIniciais] = useState(() => lerFiltrosDaUrl(location.search));

  const [loading, setLoading] = useState(true);

  const [redacoes, setRedacoes] = useState([]);
  const [temas, setTemas] = useState([]);
  const [turmas, setTurmas] = useState([]);
  const [corretores, setCorretores] = useState([]);

  const [filtro, setFiltro] = useState(filtrosIniciais.status);

  const [temaId, setTemaId] = useState(0);
  const [turmaId, setTurmaId] = useState(0);
  
  // Estados para filtros de busca
  const [buscaTema, setBuscaTema] = useState("");
  const [buscaTurma, setBuscaTurma] = useState("");
  const [buscaAluno, setBuscaAluno] = useState("");
  const [buscaCorretor, setBuscaCorretor] = useState("");
  
  // Estados para filtro por data
  const [dataInicio, setDataInicio] = useState(filtrosIniciais.dataInicio);
  const [dataFim, setDataFim] = useState(filtrosIniciais.dataFim);

  /* datas da correção, iguais às da tela do ENEM: outra pergunta, outro filtro */
  const [correcaoInicio, setCorrecaoInicio] = useState(filtrosIniciais.correcaoInicio);
  const [correcaoFim, setCorrecaoFim] = useState(filtrosIniciais.correcaoFim);

  // Estados para dropdowns dinâmicos
  const [showDropdownAluno, setShowDropdownAluno] = useState(false);
  const [showDropdownTema, setShowDropdownTema] = useState(false);
  const [showDropdownTurma, setShowDropdownTurma] = useState(false);
  const [showDropdownCorretor, setShowDropdownCorretor] = useState(false);

  // Estados para filtros selecionados
  const [alunoSelecionado, setAlunoSelecionado] = useState(filtrosIniciais.aluno);
  const [temaSelecionado, setTemaSelecionado] = useState(filtrosIniciais.tema);
  const [turmaSelecionada, setTurmaSelecionada] = useState(filtrosIniciais.turma);
  const [corretorSelecionado, setCorretorSelecionado] = useState(filtrosIniciais.corretor);
  
  // Estados para dropdown de Itens por Página
  const [itensPorPaginaDropdownAberto, setItensPorPaginaDropdownAberto] = useState(false);
  
  // Estados para dropdown de Status
  const [statusDropdownAberto, setStatusDropdownAberto] = useState(false);

  // Estados para paginação
  const [paginaAtual, setPaginaAtual] = useState(filtrosIniciais.pagina);
  const [itensPorPagina, setItensPorPagina] = useState(filtrosIniciais.porPagina);
  const [totalItens, setTotalItens] = useState(0);

  const history = useHistory();

  const user = useAuth();

  if(user.user.nivel === "e") {
    history.push("/classe");
  }

  

  // Função para mapear valores de filtro para a API
  const mapearFiltroParaAPI = (filtroValue) => {
    // Mapeamento dos valores de filtro:
    // "2" = Todas as Redações
    // "1" = Corrigidas  
    // "0" = Aguardando Correção / Pendentes
    // "3" = Envio Pendente do Aluno (novo valor que precisa ser mapeado)
    
    // Por enquanto, vamos mapear "3" para "0" até que o backend seja atualizado
    // Isso pode ser ajustado conforme a implementação do backend
    if (filtroValue === "3") {
      return "0"; // Temporariamente mapeia para Aguardando Correção / Pendentes
    }
    return filtroValue;
  };

  const getRedacoes = async (signal) => {
    try {
      let response = await api.get(`/redacao/uerj`, {
        signal: signal
      });
      if (!signal.aborted) {
        // A nova API retorna um objeto com quantidade e redacoes
        setRedacoes(response.data.redacoes || []);
      }
    } catch (err) {
      if (!signal.aborted) {
        console.error('Erro ao carregar redações:', err);
      }
    } finally {
      if (!signal.aborted) {
        setLoading(false);
      }
    }
  };

  const getTemas = async (signal) => {
    try {
      let response = await api.get(`/pegarTemasGeral`, {
        signal: signal
      });
      if (!signal.aborted) {
        setTemas(response.data);
      }
    } catch (err) {
      if (!signal.aborted) {
        console.error('Erro ao carregar temas:', err);
      }
    } finally {
      if (!signal.aborted) {
        setLoading(false);
      }
    }
  };

  const getTurmas = async (signal) => {
    try {
      let response = await api.get("/classes", {
        signal: signal
      });
      if (!signal.aborted) {
        setTurmas(response.data);
      }
    } catch (err) {
      if (!signal.aborted) {
        console.error('Erro ao carregar turmas:', err);
      }
    } finally {
      if (!signal.aborted) {
        setLoading(false);
      }
    }
  };

  const getCorretores = async (signal) => {
    try {
      let response = await api.get("/getCorretores", {
        signal: signal
      });
      if (!signal.aborted) {
        setCorretores(response.data);
      }
    } catch (err) {
      if (!signal.aborted) {
        console.error('Erro ao carregar corretores:', err);
      }
    }
  };

  /*
    Espelha os filtros na URL. `replace` e não `push`: cada tecla digitada num
    filtro não pode virar uma entrada no histórico, senão o botão voltar do
    navegador ficaria preso desfazendo filtro por filtro.
  */
  const queryDosFiltros = montarQueryDeFiltros({
    status: filtro,
    aluno: alunoSelecionado,
    tema: temaSelecionado,
    turma: turmaSelecionada,
    corretor: corretorSelecionado,
    dataInicio,
    dataFim,
    correcaoInicio,
    correcaoFim,
    pagina: paginaAtual,
    porPagina: itensPorPagina,
  });

  useEffect(() => {
    if (queryDosFiltros !== location.search) {
      history.replace(`${location.pathname}${queryDosFiltros}`);
    }
  }, [queryDosFiltros, location.pathname, location.search, history]);

  const obterNomeCorretor = (id_corretor) => {
    const corretor = corretores.find(c => c.id === id_corretor);
    return corretor ? corretor.name : 'Corretor não encontrado';
  }

  // Obter lista única de alunos das redações
  const alunosUnicos = [...new Set(redacoes.map(redacao => redacao.aluno_nome))].filter(Boolean).sort();
  
  // Filtrar alunos por busca (para dropdown) - mostra todos se busca vazia
  const alunosFiltrados = buscaAluno.length > 0 
    ? alunosUnicos.filter(aluno => aluno.toLowerCase().includes(buscaAluno.toLowerCase()))
    : alunosUnicos;

  // Filtrar temas por busca (para dropdown) - mostra todos se busca vazia
  const temasFiltrados = buscaTema.length > 0 
    ? temas.filter(tema => {
        if (!tema || !tema.genero || !tema.aula || !tema.nome) return false;
        const temaTexto = `${tema.genero} ${tema.aula} - ${tema.nome}`;
        return temaTexto.toLowerCase().includes(buscaTema.toLowerCase());
      }).sort((a, b) => {
        const temaA = `${a.genero} ${a.aula} - ${a.nome}`;
        const temaB = `${b.genero} ${b.aula} - ${b.nome}`;
        return temaA.localeCompare(temaB);
      })
    : temas.filter(tema => tema && tema.genero && tema.aula && tema.nome).sort((a, b) => {
        const temaA = `${a.genero} ${a.aula} - ${a.nome}`;
        const temaB = `${b.genero} ${b.aula} - ${b.nome}`;
        return temaA.localeCompare(temaB);
      });

  // Filtrar turmas por busca (para dropdown) - mostra todas se busca vazia
  const turmasFiltradas = buscaTurma.length > 0 
    ? turmas.filter(turma => {
        if (!turma || !turma.name) return false;
        return turma.name.toLowerCase().includes(buscaTurma.toLowerCase());
      })
    : turmas.filter(turma => turma && turma.name).sort((a, b) => a.name.localeCompare(b.name));

  // Filtrar corretores por busca (para dropdown) - mostra todos se busca vazia
  const corretoresFiltrados = buscaCorretor.length > 0 
    ? corretores.filter(corretor => {
        if (!corretor || !corretor.name) return false;
        return corretor.name.toLowerCase().includes(buscaCorretor.toLowerCase());
      })
    : corretores.filter(corretor => corretor && corretor.name).sort((a, b) => a.name.localeCompare(b.name));

  /*
    Situação da redação UERJ.

    "Em correção" é o meio do caminho: alguém já marcou — o que define o dono —
    mas ainda não finalizou. Sem esse estado, a redação aparecia como
    "Aguardando" e dois corretores podiam começar a mesma.
  */
  const situacaoDa = (redacao) => {
    if (!redacao?.status) return "sem_envio";
    if (redacao.status === "CORRIGIDA") return "corrigida";
    if (redacao.corretor_id) return "em_correcao";
    return "aguardando";
  };

  // Filtrar redações pelos filtros selecionados
  const redacoesFiltradas = redacoes.filter(redacao => {
    if (!redacao) return false;
    
    // Filtro por status - usando os novos campos da API
    if (filtro !== "2") { // Se não for "Todas as Redações"
      const situacao = situacaoDa(redacao);

      if (filtro === "1") { // Corrigidas
        if (situacao !== "corrigida") return false;
      } else if (filtro === "0") { // Aguardando: ninguém começou
        if (situacao !== "aguardando") return false;
      } else if (filtro === "4") { // Em correção: já tem dono, falta finalizar
        if (situacao !== "em_correcao") return false;
      } else if (filtro === "3") { // Envio Pendente do Aluno
        if (situacao !== "sem_envio") return false;
      }
    }
    
    /*
      Filtro por data de envio.

      As datas do input vêm como "AAAA-MM-DD", e `new Date("2026-10-09")` é lido
      como meia-noite UTC — que no horário de Brasília é 21h do dia 8. Isso
      deslocava as duas pontas: o início pegava o fim do dia anterior e o
      `setHours(23:59)` sobre essa data jogava o limite para o dia anterior,
      excluindo o último dia do intervalo. Montando a data pelos componentes, ela
      nasce no fuso local e o dia escolhido é o dia considerado.
    */
    if (dataInicio || dataFim) {
      const dataRedacao = new Date(redacao.enviada_date);

      const comoDataLocal = (iso, fimDoDia) => {
        const [ano, mes, dia] = iso.split("-").map(Number);
        return fimDoDia
          ? new Date(ano, mes - 1, dia, 23, 59, 59, 999)
          : new Date(ano, mes - 1, dia);
      };

      if (dataInicio && dataRedacao < comoDataLocal(dataInicio, false)) return false;
      if (dataFim && dataRedacao > comoDataLocal(dataFim, true)) return false;
    }

    /*
      Filtro por data da CORREÇÃO, espelhando a tela do ENEM. Redação ainda não
      corrigida não tem `corrigida_date` e fica de fora assim que este filtro é
      usado — é o esperado: a pergunta é "o que foi corrigido no período".
    */
    if (correcaoInicio || correcaoFim) {
      if (!redacao.corrigida_date) return false;

      const dataCorrecao = new Date(redacao.corrigida_date);

      const comoDataLocal = (iso, fimDoDia) => {
        const [ano, mes, dia] = iso.split("-").map(Number);
        return fimDoDia
          ? new Date(ano, mes - 1, dia, 23, 59, 59, 999)
          : new Date(ano, mes - 1, dia);
      };

      if (correcaoInicio && dataCorrecao < comoDataLocal(correcaoInicio, false)) return false;
      if (correcaoFim && dataCorrecao > comoDataLocal(correcaoFim, true)) return false;
    }
    
    // Filtro por aluno selecionado - usando aluno_nome
    if (alunoSelecionado && redacao.aluno_nome !== alunoSelecionado) return false;
    
    // Filtro por tema selecionado - usando tema_nome
    if (temaSelecionado && redacao.tema_nome !== temaSelecionado) return false;
    
    // Filtro por turma selecionada - usando classe_nome
    if (turmaSelecionada && redacao.classe_nome !== turmaSelecionada) return false;
    
    // Filtro por corretor selecionado - usando corretor_id
    if (corretorSelecionado && obterNomeCorretor(redacao.corretor_id) !== corretorSelecionado) return false;
    
    return true;
  });

  // Cálculos de paginação
  const totalPaginas = Math.ceil(redacoesFiltradas.length / itensPorPagina);
  const indiceInicial = (paginaAtual - 1) * itensPorPagina;
  const indiceFinal = indiceInicial + itensPorPagina;
  const redacoesPaginadas = redacoesFiltradas.slice(indiceInicial, indiceFinal);

  // Funções para seleção de itens nos dropdowns
  const selecionarAluno = (aluno) => {
    setAlunoSelecionado(aluno);
    setBuscaAluno("");
    setShowDropdownAluno(false);
    setPaginaAtual(1);
  };

  const selecionarTema = (tema) => {
    setTemaSelecionado(tema.tema_nome || tema.nome);
    setBuscaTema("");
    setShowDropdownTema(false);
    setPaginaAtual(1);
  };

  const selecionarTurma = (turma) => {
    setTurmaSelecionada(turma.classe_nome || turma.name);
    setBuscaTurma("");
    setShowDropdownTurma(false);
    setPaginaAtual(1);
  };

  const selecionarCorretor = (corretor) => {
    setCorretorSelecionado(corretor.name);
    setBuscaCorretor("");
    setShowDropdownCorretor(false);
    setPaginaAtual(1);
  };

  // Funções de navegação de paginação
  const irParaPagina = (pagina) => {
    setPaginaAtual(pagina);
  };

  const paginaAnterior = () => {
    if (paginaAtual > 1) {
      setPaginaAtual(paginaAtual - 1);
    }
  };

  const proximaPagina = () => {
    if (paginaAtual < totalPaginas) {
      setPaginaAtual(paginaAtual + 1);
    }
  };

  // Limpar filtros
  const limparFiltros = () => {
    setTemaId(0);
    setTurmaId(0);
    setFiltro("2");
    setBuscaTema("");
    setBuscaTurma("");
    setBuscaAluno("");
    setBuscaCorretor("");
    setAlunoSelecionado("");
    setTemaSelecionado("");
    setTurmaSelecionada("");
    setCorretorSelecionado("");
    setDataInicio("");
    setCorrecaoInicio("");
    setCorrecaoFim("");
    setDataFim("");
    setShowDropdownAluno(false);
    setShowDropdownTema(false);
    setShowDropdownTurma(false);
    setShowDropdownCorretor(false);
    setPaginaAtual(1); // Reset para primeira página
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    
    setLoading(true);
    getTemas(signal);
    getTurmas(signal);
    getCorretores(signal);
    
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    
    setLoading(true);
    getRedacoes(signal);
    
    return () => {
      controller.abort();
    };
  }, []); // Removendo dependências já que agora buscamos todas as redações

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-container')) {
        setShowDropdownAluno(false);
        setShowDropdownTema(false);
        setShowDropdownTurma(false);
        setShowDropdownCorretor(false);
        setItensPorPaginaDropdownAberto(false);
        setStatusDropdownAberto(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <Template>
      <S.MainWrapper>
        <Container fluid>
          <Row>
            <Col sm={12}>
              <S.MainContent>
                {/* Cabeçalho da página */}
                <Row>
                  <Col sm={12}>
                    <div className="shadow-sm p-4 mb-4 bg-white rounded">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <i className="fas fa-edit text-primary mr-3" style={{fontSize: '2rem'}}></i>
                          <div>
                            <h3 className="mb-0 text-dark font-weight-bold">Correção - Redações UERJ</h3>
                            <p className="mb-0 text-muted">Gerencie e corrija as redações UERJ dos alunos</p>
                          </div>
                        </div>
                        <div className="text-center">
                          <div className="display-4 text-primary font-weight-bold">
                            {redacoesFiltradas.length}
                          </div>
                          <small className="text-muted font-weight-bold">
                            {redacoesFiltradas.length === 1 ? 'redação encontrada' : 'redações encontradas'}
                          </small>
                          {redacoesFiltradas.length > 0 && (
                            <div className="mt-2">
                              <small className="text-info font-weight-bold">
                                Página {paginaAtual} de {totalPaginas} | 
                                Mostrando {indiceInicial + 1}-{Math.min(indiceFinal, redacoesFiltradas.length)} de {redacoesFiltradas.length}
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Seção de Filtros Melhorada */}
                <Row className="mb-4">
                  <Col sm={12}>
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-light border-0">
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="mb-0 text-dark font-weight-bold">
                            <i className="fas fa-filter text-primary mr-2"></i>
                            Filtros de Busca
                          </h5>
                          <button 
                            className="btn btn-outline-secondary btn-sm"
                            onClick={limparFiltros}
                          >
                            <i className="fas fa-times mr-1"></i>
                            Limpar Filtros
                          </button>
                        </div>
                      </div>
                      <div className="card-body" style={{ overflow: 'visible' }}>
                        <Row>
                          {/* Controle de Itens por Página */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group className="dropdown-container" style={{ position: 'relative' }}>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-list text-primary mr-1"></i>
                                Itens por Página
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-list"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="text"
                                  value={`${itensPorPagina} por página`}
                                  onClick={() => {
                                    setItensPorPaginaDropdownAberto(!itensPorPaginaDropdownAberto);
                                    setStatusDropdownAberto(false);
                                    setShowDropdownAluno(false);
                                    setShowDropdownTema(false);
                                    setShowDropdownTurma(false);
                                  }}
                                  readOnly
                                  className="form-control-lg"
                                  style={{ cursor: 'pointer', backgroundColor: 'white' }}
                                />
                              </InputGroup>
                              {itensPorPaginaDropdownAberto && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                    border: '1px solid #ced4da',
                                    borderTop: 'none',
                                    borderRadius: '0 0 0.25rem 0.25rem',
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    zIndex: 9999,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    marginTop: '-1px'
                                  }}
                                >
                                  {[25, 50, 100, 200].map((valor) => (
                                    <div
                                      key={valor}
                                      onClick={() => {
                                        setItensPorPagina(valor);
                                        setPaginaAtual(1);
                                        setItensPorPaginaDropdownAberto(false);
                                      }}
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        backgroundColor: itensPorPagina === valor ? '#007bff' : 'white',
                                        color: itensPorPagina === valor ? 'white' : 'black'
                                      }}
                                      onMouseEnter={(e) => {
                                        if (itensPorPagina !== valor) {
                                          e.target.style.backgroundColor = '#f8f9fa';
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        if (itensPorPagina !== valor) {
                                          e.target.style.backgroundColor = 'white';
                                        }
                                      }}
                                    >
                                      {valor} por página
                                    </div>
                                  ))}
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          {/* Filtro por Status */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group className="dropdown-container" style={{ position: 'relative' }}>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-info-circle text-primary mr-1"></i>
                                Status
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-flag"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="text"
                                  value={
                                    filtro === "2" ? "Todas as Redações" :
                                    filtro === "1" ? "Corrigidas" :
                                    filtro === "0" ? "Aguardando Correção" :
                                    filtro === "4" ? "Em correção" :
                                    filtro === "3" ? "Envio Pendente do Aluno" : "Todas as Redações"
                                  }
                                  onClick={() => {
                                    setStatusDropdownAberto(!statusDropdownAberto);
                                    setItensPorPaginaDropdownAberto(false);
                                    setShowDropdownAluno(false);
                                    setShowDropdownTema(false);
                                    setShowDropdownTurma(false);
                                  }}
                                  readOnly
                                  className="form-control-lg"
                                  style={{ cursor: 'pointer', backgroundColor: 'white' }}
                                />
                              </InputGroup>
                              {statusDropdownAberto && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                    border: '1px solid #ced4da',
                                    borderTop: 'none',
                                    borderRadius: '0 0 0.25rem 0.25rem',
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    zIndex: 9999,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    marginTop: '-1px'
                                  }}
                                >
                                  {[
                                    { value: "2", label: "Todas as Redações" },
                                    { value: "1", label: "Corrigidas" },
                                    { value: "0", label: "Aguardando Correção" },
                                    { value: "4", label: "Em correção" },
                                    { value: "3", label: "Envio Pendente do Aluno" }
                                  ].map((opcao) => (
                                    <div
                                      key={opcao.value}
                                      onClick={() => {
                                        setFiltro(opcao.value);
                                        setPaginaAtual(1);
                                        setStatusDropdownAberto(false);
                                      }}
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        backgroundColor: filtro === opcao.value ? '#007bff' : 'white',
                                        color: filtro === opcao.value ? 'white' : 'black'
                                      }}
                                      onMouseEnter={(e) => {
                                        if (filtro !== opcao.value) {
                                          e.target.style.backgroundColor = '#f8f9fa';
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        if (filtro !== opcao.value) {
                                          e.target.style.backgroundColor = 'white';
                                        }
                                      }}
                                    >
                                      {opcao.label}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          {/* Filtro por Aluno */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group className="dropdown-container" style={{ position: 'relative' }}>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-user text-primary mr-1"></i>
                                Aluno
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-user"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="text"
                                  placeholder={alunoSelecionado || "Buscar aluno..."}
                                  value={buscaAluno}
                                  onChange={(e) => setBuscaAluno(e.target.value)}
                                  onFocus={() => {
                                    setShowDropdownAluno(true);
                                    setShowDropdownTema(false);
                                    setShowDropdownTurma(false);
                                    setShowDropdownCorretor(false);
                                    setItensPorPaginaDropdownAberto(false);
                                    setStatusDropdownAberto(false);
                                  }}
                                  className="form-control-lg"
                                />
                                {alunoSelecionado && (
                                  <InputGroup.Append>
                                    <button
                                      className="btn btn-outline-secondary"
                                      type="button"
                                      onClick={() => {
                                        setAlunoSelecionado("");
                                        setBuscaAluno("");
                                        setPaginaAtual(1);
                                      }}
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </InputGroup.Append>
                                )}
                              </InputGroup>
                              {showDropdownAluno && alunosFiltrados.length > 0 && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                    border: '1px solid #ced4da',
                                    borderTop: 'none',
                                    borderRadius: '0 0 0.25rem 0.25rem',
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    zIndex: 9999,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    marginTop: '-1px'
                                  }}
                                >
                                  {alunosFiltrados.map((aluno, index) => (
                                    <div
                                      key={index}
                                      onClick={() => selecionarAluno(aluno)}
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        backgroundColor: 'white'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'white';
                                      }}
                                    >
                                      {aluno}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          {/* Filtro por Tema */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group className="dropdown-container" style={{ position: 'relative' }}>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-book text-primary mr-1"></i>
                                Tema
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-book"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="text"
                                  placeholder={temaSelecionado || "Buscar tema..."}
                                  value={buscaTema}
                                  onChange={(e) => setBuscaTema(e.target.value)}
                                  onFocus={() => {
                                    setShowDropdownTema(true);
                                    setShowDropdownAluno(false);
                                    setShowDropdownTurma(false);
                                    setShowDropdownCorretor(false);
                                    setItensPorPaginaDropdownAberto(false);
                                    setStatusDropdownAberto(false);
                                  }}
                                  className="form-control-lg"
                                />
                                {temaSelecionado && (
                                  <InputGroup.Append>
                                    <button
                                      className="btn btn-outline-secondary"
                                      type="button"
                                      onClick={() => {
                                        setTemaSelecionado("");
                                        setBuscaTema("");
                                        setPaginaAtual(1);
                                      }}
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </InputGroup.Append>
                                )}
                              </InputGroup>
                              {showDropdownTema && temasFiltrados.length > 0 && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                    border: '1px solid #ced4da',
                                    borderTop: 'none',
                                    borderRadius: '0 0 0.25rem 0.25rem',
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    zIndex: 9999,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    marginTop: '-1px'
                                  }}
                                >
                                  {temasFiltrados.map((tema, index) => (
                                    <div
                                      key={index}
                                      onClick={() => selecionarTema(tema)}
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        backgroundColor: 'white'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'white';
                                      }}
                                    >
                                      {tema.genero} {tema.aula} - {tema.nome}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          {/* Filtro por Turma */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group className="dropdown-container" style={{ position: 'relative' }}>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-users text-primary mr-1"></i>
                                Turma
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-users"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="text"
                                  placeholder={turmaSelecionada || "Buscar turma..."}
                                  value={buscaTurma}
                                  onChange={(e) => setBuscaTurma(e.target.value)}
                                  onFocus={() => {
                                    setShowDropdownTurma(true);
                                    setShowDropdownAluno(false);
                                    setShowDropdownTema(false);
                                    setShowDropdownCorretor(false);
                                    setItensPorPaginaDropdownAberto(false);
                                    setStatusDropdownAberto(false);
                                  }}
                                  className="form-control-lg"
                                />
                                {turmaSelecionada && (
                                  <InputGroup.Append>
                                    <button
                                      className="btn btn-outline-secondary"
                                      type="button"
                                      onClick={() => {
                                        setTurmaSelecionada("");
                                        setBuscaTurma("");
                                        setPaginaAtual(1);
                                      }}
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </InputGroup.Append>
                                )}
                              </InputGroup>
                              {showDropdownTurma && turmasFiltradas.length > 0 && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                    border: '1px solid #ced4da',
                                    borderTop: 'none',
                                    borderRadius: '0 0 0.25rem 0.25rem',
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    zIndex: 9999,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    marginTop: '-1px'
                                  }}
                                >
                                  {turmasFiltradas.map((turma, index) => (
                                    <div
                                      key={index}
                                      onClick={() => selecionarTurma(turma)}
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        backgroundColor: 'white'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'white';
                                      }}
                                    >
                                      {turma.name}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          {/* Filtro por Corretor */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group className="dropdown-container" style={{ position: 'relative' }}>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-user-check text-primary mr-1"></i>
                                Corretor
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-user-check"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="text"
                                  placeholder={corretorSelecionado || "Buscar corretor..."}
                                  value={buscaCorretor}
                                  onChange={(e) => setBuscaCorretor(e.target.value)}
                                  onFocus={() => {
                                    setShowDropdownCorretor(true);
                                    setShowDropdownAluno(false);
                                    setShowDropdownTema(false);
                                    setShowDropdownTurma(false);
                                    setItensPorPaginaDropdownAberto(false);
                                    setStatusDropdownAberto(false);
                                  }}
                                  className="form-control-lg"
                                />
                                {corretorSelecionado && (
                                  <InputGroup.Append>
                                    <button
                                      className="btn btn-outline-secondary"
                                      type="button"
                                      onClick={() => {
                                        setCorretorSelecionado("");
                                        setBuscaCorretor("");
                                        setPaginaAtual(1);
                                      }}
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </InputGroup.Append>
                                )}
                              </InputGroup>
                              {showDropdownCorretor && corretoresFiltrados.length > 0 && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                    border: '1px solid #ced4da',
                                    borderTop: 'none',
                                    borderRadius: '0 0 0.25rem 0.25rem',
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    zIndex: 9999,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    marginTop: '-1px'
                                  }}
                                >
                                  {corretoresFiltrados.map((corretor, index) => (
                                    <div
                                      key={index}
                                      onClick={() => selecionarCorretor(corretor)}
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        backgroundColor: 'white'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'white';
                                      }}
                                    >
                                      {corretor.name}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          {/* Filtro por Data de Início */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-calendar-alt text-primary mr-1"></i>
                                Enviada a partir de
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-calendar-alt"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="date"
                                  value={dataInicio}
                                  onChange={(e) => {
                                    setDataInicio(e.target.value);
                                    setPaginaAtual(1);
                                  }}
                                  className="form-control-lg"
                                />
                              </InputGroup>
                              {dataInicio && (
                                <div className="mt-1">
                                  <span className="badge badge-secondary">
                                    Desde: {dataBR(dataInicio)}
                                  </span>
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          {/* Filtro por Data de Fim */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-calendar-alt text-primary mr-1"></i>
                                Enviada até
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-calendar-alt"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="date"
                                  value={dataFim}
                                  onChange={(e) => {
                                    setDataFim(e.target.value);
                                    setPaginaAtual(1);
                                  }}
                                  className="form-control-lg"
                                />
                              </InputGroup>
                              {dataFim && (
                                <div className="mt-1">
                                  <span className="badge badge-secondary">
                                    Até: {dataBR(dataFim)}
                                  </span>
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          {/* Datas da correção — mesmo par da tela do ENEM */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-check-double text-success mr-1"></i>
                                Corrigida a partir de
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-calendar-check"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="date"
                                  value={correcaoInicio}
                                  onChange={(e) => {
                                    setCorrecaoInicio(e.target.value);
                                    setPaginaAtual(1);
                                  }}
                                  className="form-control-lg"
                                />
                              </InputGroup>
                              {correcaoInicio && (
                                <div className="mt-1">
                                  <span className="badge badge-success">
                                    Desde: {dataBR(correcaoInicio)}
                                  </span>
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-check-double text-success mr-1"></i>
                                Corrigida até
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-calendar-check"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="date"
                                  value={correcaoFim}
                                  onChange={(e) => {
                                    setCorrecaoFim(e.target.value);
                                    setPaginaAtual(1);
                                  }}
                                  className="form-control-lg"
                                />
                              </InputGroup>
                              {correcaoFim && (
                                <div className="mt-1">
                                  <span className="badge badge-success">
                                    Até: {dataBR(correcaoFim)}
                                  </span>
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Tabela de Redações */}
                <Row>
                  <Col sm={12}>
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-light border-0">
                        <h5 className="mb-0 text-dark font-weight-bold">
                          <i className="fas fa-table text-primary mr-2"></i>
                          Lista de Redações UERJ
                        </h5>
                      </div>
                      <div className="card-body p-0">
                        {loading ? (
                          <div className="text-center p-5">
                            <div className="spinner-border text-primary" role="status">
                              <span className="sr-only">Carregando...</span>
                            </div>
                            <p className="mt-3 text-muted">Carregando redações...</p>
                          </div>
                        ) : redacoesPaginadas.length === 0 ? (
                          <div className="text-center p-5">
                            <i className="fas fa-search text-muted" style={{fontSize: '3rem'}}></i>
                            <h5 className="mt-3 text-muted">Nenhuma redação encontrada</h5>
                            <p className="text-muted">Tente ajustar os filtros de busca</p>
                          </div>
                        ) : (
                          <div className="table-responsive">
                            <table className="table table-hover mb-0">
                              <thead className="thead-light">
                                <tr>
                                  <th className="border-0 font-weight-bold text-dark" style={{width: '22%', minWidth: '190px', whiteSpace: 'nowrap'}}>
                                    <i className="fas fa-user mr-1"></i>
                                    Aluno
                                  </th>
                                  <th className="border-0 font-weight-bold text-dark" style={{width: '24%', whiteSpace: 'nowrap'}}>
                                    <i className="fas fa-book mr-1"></i>
                                    Tema
                                  </th>
                                  <th className="border-0 font-weight-bold text-dark" style={{width: '12%', maxWidth: '150px', whiteSpace: 'nowrap'}}>
                                    <i className="fas fa-users mr-1"></i>
                                    Turma
                                  </th>
                                  <th className="border-0 font-weight-bold text-dark" style={{width: '9%', whiteSpace: 'nowrap'}}>
                                    <i className="fas fa-calendar mr-1"></i>
                                    Enviada
                                  </th>
                                  {/* data da entrega da correção, como na tela do ENEM */}
                                  <th className="border-0 font-weight-bold text-dark" style={{width: '9%', whiteSpace: 'nowrap'}}>
                                    <i className="fas fa-calendar-check mr-1"></i>
                                    Corrigida
                                  </th>
                                  <th className="border-0 font-weight-bold text-dark" style={{width: '11%', whiteSpace: 'nowrap'}}>
                                    <i className="fas fa-info-circle mr-1"></i>
                                    Status
                                  </th>
                                  <th className="border-0 font-weight-bold text-dark" style={{width: '12%', minWidth: '125px', whiteSpace: 'nowrap'}}>
                                    <i className="fas fa-user-check mr-1"></i>
                                    Corretor
                                  </th>
                                  <th className="border-0 font-weight-bold text-dark text-center" style={{width: '11%', whiteSpace: 'nowrap'}}>
                                    <i className="fas fa-cogs mr-1"></i>
                                    Ações
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {redacoesPaginadas.map((redacao, index) => (
                                  <tr key={index} className="border-bottom">
                                    <td className="align-middle">
                                      <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                        <MiniaturaFoto
                                          foto={redacao.aluno_foto}
                                          nome={redacao.aluno_nome}
                                        />
                                        <span className="font-weight-medium text-dark">
                                          {redacao.aluno_nome || 'Nome não disponível'}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="align-middle">
                                      <span className="text-dark font-weight-medium">
                                        {redacao.tema_nome || 'Tema não disponível'}
                                      </span>
                                    </td>
                                    <td className="align-middle">
                                      {/* badge do BS4 é nowrap: liberado para quebrar linha, senão o nome da turma alarga a coluna */}
                                      <span
                                        className="badge badge-info px-2 py-1"
                                        style={{whiteSpace: 'normal', textAlign: 'left'}}
                                      >
                                        {redacao.classe_nome || 'Turma não disponível'}
                                      </span>
                                    </td>
                                    <td className="align-middle">
                                      <span className="text-muted">
                                        {redacao.enviada_date ? new Date(redacao.enviada_date).toLocaleDateString('pt-BR') : 'Data não disponível'}
                                      </span>
                                    </td>
                                    <td className="align-middle">
                                      {/* só quando finalizada: antes disso a correção não terminou */}
                                      <span className="text-muted">
                                        {situacaoDa(redacao) === "corrigida" && redacao.corrigida_date
                                          ? new Date(redacao.corrigida_date).toLocaleDateString('pt-BR')
                                          : '—'}
                                      </span>
                                    </td>
                                    <td className="align-middle">
                                      {situacaoDa(redacao) === "corrigida" ? (
                                        <span className="badge badge-success px-2 py-1">
                                          <i className="fas fa-check mr-1"></i>
                                          Corrigida
                                        </span>
                                      ) : situacaoDa(redacao) === "em_correcao" ? (
                                        <span className="badge badge-info px-2 py-1">
                                          <i className="fas fa-pen mr-1"></i>
                                          Em correção
                                        </span>
                                      ) : redacao.status ? (
                                        <span className="badge badge-warning px-2 py-1">
                                          <i className="fas fa-clock mr-1"></i>
                                          Aguardando Correção
                                        </span>
                                      ) : (
                                        <span className="badge badge-secondary px-2 py-1">
                                          <i className="fas fa-hourglass-half mr-1"></i>
                                          Envio Pendente
                                        </span>
                                      )}
                                    </td>
                                    <td className="align-middle">
                                      <span className="text-dark">
                                        {redacao.corretor_id ? obterNomeCorretor(redacao.corretor_id) : 'Não atribuído'}
                                      </span>
                                    </td>
                                    <td className="align-middle text-center">
                                      {situacaoDa(redacao) !== "corrigida" ? (
                                        <Link
                                          to={{
                                            pathname: `/correcao-uerj/${redacao.id_redacao}`,
                                            // leva a lista filtrada junto, para o "Voltar" devolver exatamente ela
                                            state: { voltarPara: `${location.pathname}${queryDosFiltros}` },
                                          }}
                                          className={`btn btn-sm ${situacaoDa(redacao) === "em_correcao" ? "btn-info" : "btn-danger"}`}
                                          title={
                                            situacaoDa(redacao) === "em_correcao"
                                              ? `Correção iniciada por ${obterNomeCorretor(redacao.corretor_id)}`
                                              : "Começar a correção desta redação"
                                          }
                                        >
                                          <i className="fas fa-edit me-1"></i>
                                          {situacaoDa(redacao) === "em_correcao" ? "Continuar Correção" : "Fazer Correção"}
                                        </Link>
                                      ) : (
                                        <Link
                                          to={{
                                            pathname: `/correcao-uerj/${redacao.id_redacao}`,
                                            state: { voltarPara: `${location.pathname}${queryDosFiltros}` },
                                          }}
                                          className="btn btn-sm btn-warning"
                                        >
                                          <i className="fas fa-edit me-1"></i>
                                          Editar Correção
                                        </Link>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                    {/* Controles de Paginação */}
                    {redacoesFiltradas.length > 0 && totalPaginas > 1 && (
                      <div className="d-flex justify-content-between align-items-center mt-4 p-3 bg-light rounded">
                        <div className="d-flex align-items-center">
                          <span className="text-muted mr-3">
                            <strong>Página {paginaAtual} de {totalPaginas}</strong>
                          </span>
                          <span className="text-muted">
                            ({indiceInicial + 1}-{Math.min(indiceFinal, redacoesFiltradas.length)} de {redacoesFiltradas.length} redações)
                          </span>
                        </div>
                        
                        <div className="d-flex align-items-center">
                          {/* Botão Primeira Página */}
                          <button
                            className="btn btn-outline-primary btn-sm mr-1"
                            onClick={() => irParaPagina(1)}
                            disabled={paginaAtual === 1}
                          >
                            <i className="fas fa-angle-double-left"></i>
                          </button>
                          
                          {/* Botão Página Anterior */}
                          <button
                            className="btn btn-outline-primary btn-sm mr-2"
                            onClick={paginaAnterior}
                            disabled={paginaAtual === 1}
                          >
                            <i className="fas fa-angle-left mr-1"></i>
                            Anterior
                          </button>

                          {/* Números das Páginas */}
                          <div className="d-flex">
                            {Array.from({ length: Math.min(5, totalPaginas) }, (_, i) => {
                              let pageNum;
                              if (totalPaginas <= 5) {
                                pageNum = i + 1;
                              } else if (paginaAtual <= 3) {
                                pageNum = i + 1;
                              } else if (paginaAtual >= totalPaginas - 2) {
                                pageNum = totalPaginas - 4 + i;
                              } else {
                                pageNum = paginaAtual - 2 + i;
                              }
                              
                              return (
                                <button
                                  key={pageNum}
                                  className={`btn btn-sm mr-1 ${
                                    pageNum === paginaAtual 
                                      ? 'btn-primary' 
                                      : 'btn-outline-primary'
                                  }`}
                                  onClick={() => irParaPagina(pageNum)}
                                >
                                  {pageNum}
                                </button>
                              );
                            })}
                          </div>

                          {/* Botão Próxima Página */}
                          <button
                            className="btn btn-outline-primary btn-sm ml-2"
                            onClick={proximaPagina}
                            disabled={paginaAtual === totalPaginas}
                          >
                            Próxima
                            <i className="fas fa-angle-right ml-1"></i>
                          </button>
                          
                          {/* Botão Última Página */}
                          <button
                            className="btn btn-outline-primary btn-sm ml-1"
                            onClick={() => irParaPagina(totalPaginas)}
                            disabled={paginaAtual === totalPaginas}
                          >
                            <i className="fas fa-angle-double-right"></i>
                          </button>
                        </div>
                      </div>
                    )}
              </S.MainContent>
            </Col>
          </Row>
        </Container>
      </S.MainWrapper>
    </Template>
  );
}

export default RedacoesUERJ;